// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23.5\" height=\"119.5\" viewBox=\"0 0 23.5 119.5\"> <path data-name=\"Path 6\" d=\"M23,0H4A4,4,0,0,0,0,4V119\" transform=\"translate(0.5 0.5)\" fill=\"none\" stroke=\"#ed0206\" stroke-miterlimit=\"10\" stroke-width=\"1\"/> </svg> ";
// Exports
module.exports = code;